/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Typography} from "@material-ui/core";

const styles = theme => ({
    hoursNavigationContainer: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        overflow: "hidden",
    },
    navigationCenterText: {
        position: "relative",
        textAlign: "center",
        display: "block",
        backgroundColor: "white",
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
    },
    hourAlignment: {
        transform: "translate(-50%, -50%)",
        left: "50%",
        position: "relative",
        top: "50%",
    },
    hoursIsSelected: {
        backgroundColor: theme.palette.secondary.A100,
    },
    raster: {},
    hourRasterDense: {},
    hourRasterWide: {},
    hoursNavigationWidth: {
        height: "100%",
    },
    dayRasterDense: {},
    dayRasterWide: {},
});

class HoursNavigation extends React.Component {

    constructor(props) {
        super(props);
        this.props.onRef(this);
    }

    scrollTop = (top) => {
        const {hours} = this.refs;
        hours.scrollTop = top;
    };

    render() {
        const {classes} = this.props;
        let hoursArray = [];
        for (let i = 0; i < 24; i++) {
            const hourLabel = ("0" + i).slice(-2) + "-" + ("0" + (i + 1)).slice(-2);
            const hourSelectedClass = this.props.hoveredHour === i ? " " + classes.hoursIsSelected : "";
            const heightClass = this.props.dense ? classes.hourRasterDense : classes.hourRasterWide;
            hoursArray[i] = <div key={"navigation" + i} className={hourSelectedClass + " " + heightClass + " " + classes.raster}>
                <Typography align="center"
                            className={classes.hourAlignment}>{hourLabel}</Typography>
            </div>;
        }
        return <div className={classes.hoursNavigationWidth}>
            <div className={classes.hoursNavigationContainer} ref="hours">{hoursArray}</div>
        </div>;
    }
}

HoursNavigation.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HoursNavigation, {name: "hourPanel"});